// extracted by mini-css-extract-plugin
export default {"dlStaticTextInput":"src-js-containers-auto_layout-components-dynamic-StaticText---dlStaticTextInput---0vFUE"};